import script from "./CorporateHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateHeader.vue?vue&type=style&index=0&id=f2b0ae44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b0ae44"]])

export default __exports__